export default {
  props: ['loftiePlusProductTitle', 'currency_symbol'],
   methods: {
    closeUpsell() {
      window.store.commit('toggleLoftiePlusUpsell', false);
    },
    showTakeover() {
      window.store.commit('toggleLoftiePlusUpsell', false);
      window.store.commit('toggleLoftiePlusFeatures', true);
    },
    addToCart() {
      const formData = {
        items: [
          {
            id: 43919100313847,
            quantity: 1,
            selling_plan: 3004629239
          }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
        .then(response => {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(json => {
          console.log('Added to cart:', json);
          // Optionally trigger cart drawer or redirect
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
        });
    }
  },
  template: `
    <div class="lpt_upsell--wrapper">
      <h4 class="lpt_upsell--header">Get the most out of your Loftie Clock:</h4>
      <div class="lpt_upsell--border_wrapper">
        <div class="lpt_upsell--slide">
          <svg id="loftiePlusCloseIcon" width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" @click="closeUpsell">
            <g clip-path="url(#clip0_1634_16194)">
              <path d="M0.416992 0.416016L19.5837 19.5827" stroke="#909090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19.5837 0.416016L0.416992 19.5827" stroke="#909090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_1634_16194">
                <rect width="20" height="20" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <img class="lpt_upsell--img"  src="https://cdn.shopify.com/s/files/1/0268/3823/7231/files/LoftieSystem.jpg?v=1750102329&width=200" :alt="loftiePlusProductTitle" >
          <div class="lpt_upsell--right_column">
            <h5 class="lpt_upsell--title">Loftie Rest</h5>
            <h6 class="lpt_upsell--subtitle">Save {{currency_symbol}}20 today</h6>
            <button class="lpt_upsell--btn" @click="addToCart">
              <span>Free Trial</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
}

